import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'Beranda',
    component: () => import('../../components/views/Publik/Beranda.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/Login',
    name: 'Login',
    component: () => import('../../components/views/Publik/Login.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/AksiLogin',
    name: 'AksiLogin',
    component: () => import('../../components/views/Publik/AksiLogin.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/KontakKami',
    name: 'KontakKami',
    component: () => import('../../components/views/Publik/KontakKami.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/MasukanSaran',
    name: 'MasukanSaran',
    component: () => import('../../components/views/Publik/MasukanSaran.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/DaftarStatus',
    name: 'DaftarStatus',
    component: () => import('../../components/views/Publik/DaftarStatus.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/DaftarProgramBudgeting',
    name: 'DaftarProgramBudgeting',
    component: () => import('../../components/views/Publik/DaftarProgramBudgeting.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/DaftarFinance',
    name: 'DaftarFinance',
    component: () => import('../../components/views/Publik/DaftarFinance.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/DaftarMonev',
    name: 'DaftarMonev',
    component: () => import('../../components/views/Publik/DaftarMonev.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/DaftarPDOIOS',
    name: 'DaftarPDOIOS',
    component: () => import('../../components/views/Publik/DaftarPDOIOS.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/DaftarQuickStatus',
    name: 'DaftarQuickStatus',
    component: () => import('../../components/views/Publik/DaftarQuickStatus.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/DaftarAduan',
    name: 'DaftarAduan',
    component: () => import('../../components/views/Publik/DaftarAduan.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/DaftarTimPelaksana',
    name: 'DaftarTimPelaksana',
    component: () => import('../../components/views/Publik/DaftarTimPelaksana.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/DaftarAgenda',
    name: 'DaftarAgenda',
    component: () => import('../../components/views/Publik/DaftarAgenda.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/Aduan',
    name: 'Aduan',
    component: () => import('../../components/views/Publik/Aduan.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/FAQ',
    name: 'FAQ',
    component: () => import('../../components/views/Publik/FAQ.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/CariAduan',
    name: 'CariAduan',
    component: () => import('../../components/views/Publik/CariAduan.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/Dashboard',
    name: 'Dashboard',
    component: () => import('../../components/views/Dashboard/Dashboard.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/Aksi',
    name: 'Aksi',
    component: () => import('../../components/views/Aksi/Aksi.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/Google',
    name: 'Google',
    component: () => import('../../components/views/Aksi/Google.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/Izin',
    name: 'Izin',
    component: () => import('../../components/views/Aksi/Izin.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/DL',
    name: 'DL',
    component: () => import('../../components/views/Aksi/DL.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ProfilAksi',
    name: 'ProfilAksi',
    component: () => import('../../components/views/Aksi/ProfilAksi.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/Statistik',
    name: 'Statistik',
    component: () => import('../../components/views/Aksi/Statistik.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/Regulasi',
    name: 'Regulasi',
    component: () => import('../../components/views/Backoffice/Regulasi/Regulasi.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ProsesRegulasi/:id',
    name: 'ProsesRegulasi',
    component: () => import('../../components/views/Backoffice/Regulasi/ProsesRegulasi.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/DaftarRegulasi',
    name: 'DaftarRegulasi',
    component: () => import('../../components/views/Publik/DaftarRegulasi.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/Slider',
    name: 'Slider',
    component: () => import('../../components/views/Backoffice/Slider/Slider.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ProsesSlider/:id',
    name: 'ProsesSlider',
    component: () => import('../../components/views/Backoffice/Slider/ProsesSlider.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/Kategori',
    name: 'Kategori',
    component: () => import('../../components/views/Backoffice/Kategori/Kategori.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ProsesKategori/:id',
    name: 'ProsesKategori',
    component: () => import('../../components/views/Backoffice/Kategori/ProsesKategori.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/SubKategori',
    name: 'SubKategori',
    component: () => import('../../components/views/Backoffice/SubKategori/SubKategori.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ProsesSubKategori/:id',
    name: 'ProsesSubKategori',
    component: () => import('../../components/views/Backoffice/SubKategori/ProsesSubKategori.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/UnitKategori',
    name: 'UnitKategori',
    component: () => import('../../components/views/Backoffice/UnitKategori/UnitKategori.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ProsesUnitKategori/:id',
    name: 'ProsesUnitKategori',
    component: () => import('../../components/views/Backoffice/UnitKategori/ProsesUnitKategori.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/InfoBeranda',
    name: 'InfoBeranda',
    component: () => import('../../components/views/Backoffice/InfoBeranda/InfoBeranda.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ProsesInfoBeranda/:id',
    name: 'ProsesInfoBeranda',
    component: () => import('../../components/views/Backoffice/InfoBeranda/ProsesInfoBeranda.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/Konten',
    name: 'Konten',
    component: () => import('../../components/views/Backoffice/Konten/Konten.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ProsesKonten/:id',
    name: 'ProsesKonten',
    component: () => import('../../components/views/Backoffice/Konten/ProsesKonten.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/User',
    name: 'User',
    component: () => import('../../components/views/Backoffice/User/User.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ProsesUser/:id',
    name: 'ProsesUser',
    component: () => import('../../components/views/Backoffice/User/ProsesUser.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/TimPelaksana',
    name: 'TimPelaksana',
    component: () => import('../../components/views/Backoffice/TimPelaksana/TimPelaksana.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ProsesTimPelaksana/:id',
    name: 'ProsesTimPelaksana',
    component: () => import('../../components/views/Backoffice/TimPelaksana/ProsesTimPelaksana.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/Inbox',
    name: 'Inbox',
    component: () => import('../../components/views/Backoffice/Inbox/Inbox.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ProsesInbox/:id',
    name: 'ProsesInbox',
    component: () => import('../../components/views/Backoffice/Inbox/ProsesInbox.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/Kalendar',
    name: 'Kalendar',
    component: () => import('../../components/views/Backoffice/Kalendar/Kalendar.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ProsesKalendar/:id',
    name: 'ProsesKalendar',
    component: () => import('../../components/views/Backoffice/Kalendar/ProsesKalendar.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ViewKalendar/:id',
    name: 'ViewKalendar',
    component: () => import('../../components/views/Backoffice/Kalendar/ViewKalendar.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/Monev/:id',
    name: 'Monev',
    component: () => import('../../components/views/Backoffice/Monev/Monev.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ProsesMonev/:id',
    name: 'ProsesMonev',
    component: () => import('../../components/views/Backoffice/Monev/ProsesMonev.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ProsesPDOMonev/:id',
    name: 'ProsesPDOMonev',
    component: () => import('../../components/views/Backoffice/Monev/ProsesPDOMonev.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ProsesKurvaS/:id',
    name: 'ProsesKurvaS',
    component: () => import('../../components/views/Backoffice/Monev/ProsesKurvaS.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/KendalaTindakLanjut/:id',
    name: 'KendalaTindakLanjut',
    component: () => import('../../components/views/Backoffice/Monev/KendalaTindakLanjut.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/PDO3/:id',
    name: 'PDO3',
    component: () => import('../../components/views/Backoffice/Monev/PDO3.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/PDO11/:id',
    name: 'PDO11',
    component: () => import('../../components/views/Backoffice/Monev/PDO11.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/PDO3Rapat/:id',
    name: 'PDO3Rapat',
    component: () => import('../../components/views/Backoffice/Monev/PDO3Rapat.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/PDO2/:id',
    name: 'PDO2',
    component: () => import('../../components/views/Backoffice/Monev/PDO2.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/PDO1/:id',
    name: 'PDO1',
    component: () => import('../../components/views/Backoffice/Monev/PDO1.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/PDO7/:id',
    name: 'PDO7',
    component: () => import('../../components/views/Backoffice/Monev/PDO1.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/IPP',
    name: 'IPP',
    component: () => import('../../components/views/Backoffice/IPP/IPP.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/GAP',
    name: 'GAP',
    component: () => import('../../components/views/Backoffice/GAP/GAP.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/PDOIOS',
    name: 'PDOIOS',
    component: () => import('../../components/views/Backoffice/PDOIOS/PDOIOS.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ImportExcel',
    name: 'ImportExcel',
    component: () => import('../../components/views/ImportExcel/ImportExcel.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/CEMP',
    name: 'CEMP',
    component: () => import('../../components/views/Backoffice/CEMP/CEMP.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/RKLRPL',
    name: 'RKLRPL',
    component: () => import('../../components/views/Backoffice/RKLRPL/RKLRPL.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/Sampel',
    name: 'Sampel',
    component: () => import('../../components/views/Backoffice/Sampel/Sampel.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/KategoriData',
    name: 'KategoriData',
    component: () => import('../../components/views/Backoffice/KategoriData/KategoriData.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ProsesKategoriData/:id',
    name: 'ProsesKategoriData',
    component: () => import('../../components/views/Backoffice/KategoriData/ProsesKategoriData.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/AduanMasyarakat/:id',
    name: 'AduanMasyarakat',
    component: () => import('../../components/views/Backoffice/AduanMasyarakat/AduanMasyarakat.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ProsesAduanMasyarakat/:id',
    name: 'ProsesAduanMasyarakat',
    component: () => import('../../components/views/Backoffice/AduanMasyarakat/ProsesAduanMasyarakat.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/TindaklanjutAduanMasyarakat/:id',
    name: 'TindaklanjutAduanMasyarakat',
    component: () => import('../../components/views/Backoffice/AduanMasyarakat/TindaklanjutAduanMasyarakat.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/LayerPeta',
    name: 'LayerPeta',
    component: () => import('../../components/views/Backoffice/LayerPeta/LayerPeta.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ProsesLayerPeta/:id',
    name: 'ProsesLayerPeta',
    component: () => import('../../components/views/Backoffice/LayerPeta/ProsesLayerPeta.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/GIS/:id',
    name: 'GIS',
    component: () => import('../../components/views/Publik/GIS.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/DaftarKonten/:id',
    name: 'DaftarKonten',
    component: () => import('../../components/views/Publik/DaftarKonten.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/DaftarKegiatan',
    name: 'DaftarKegiatan',
    component: () => import('../../components/views/Publik/DaftarKegiatan.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/Berita',
    name: 'Berita',
    component: () => import('../../components/views/Backoffice/Berita/Berita.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ProsesBerita/:id',
    name: 'ProsesBerita',
    component: () => import('../../components/views/Backoffice/Berita/ProsesBerita.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/DaftarBerita',
    name: 'DaftarBerita',
    component: () => import('../../components/views/Publik/DaftarBerita.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/Galeri',
    name: 'Galeri',
    component: () => import('../../components/views/Backoffice/Galeri/Galeri.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ProsesGaleri/:id',
    name: 'ProsesGaleri',
    component: () => import('../../components/views/Backoffice/Galeri/ProsesGaleri.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/DetailGaleri/:id',
    name: 'DetailGaleri',
    component: () => import('../../components/views/Backoffice/Galeri/DetailGaleri.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/DaftarAlbum',
    name: 'DaftarAlbum',
    component: () => import('../../components/views/Publik/DaftarAlbum.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/DaftarGaleri/:id',
    name: 'DaftarGaleri',
    component: () => import('../../components/views/Publik/DaftarGaleri.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/Dokumen',
    name: 'Dokumen',
    component: () => import('../../components/views/Backoffice/Dokumen/Dokumen.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ProsesDokumen/:id',
    name: 'ProsesDokumen',
    component: () => import('../../components/views/Backoffice/Dokumen/ProsesDokumen.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/DetailDokumen/:id',
    name: 'DetailDokumen',
    component: () => import('../../components/views/Backoffice/Dokumen/DetailDokumen.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/DaftarAlbumDokumen',
    name: 'DaftarAlbumDokumen',
    component: () => import('../../components/views/Publik/DaftarAlbumDokumen.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/DaftarAlbumDocumen',
    name: 'DaftarAlbumDocumen',
    component: () => import('../../components/views/Publik/DaftarAlbumDocumen.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/DaftarGaleriDokumen/:id',
    name: 'DaftarGaleriDokumen',
    component: () => import('../../components/views/Publik/DaftarGaleriDokumen.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/DataDokumen',
    name: 'DataDokumen',
    component: () => import('../../components/views/Backoffice/NewDokumen/Dokumen.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/Environment/:id',
    name: 'Environment',
    component: () => import('../../components/views/Backoffice/Environment/Environment.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ProsesEnvironment/:id',
    name: 'ProsesEnvironment',
    component: () => import('../../components/views/Backoffice/Environment/ProsesEnvironment.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/Social/:id',
    name: 'Social',
    component: () => import('../../components/views/Backoffice/Social/Social.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ProsesSocial/:id',
    name: 'ProsesSocial',
    component: () => import('../../components/views/Backoffice/Social/ProsesSocial.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/Konsultan',
    name: 'Konsultan',
    component: () => import('../../components/views/Backoffice/Konsultan/Monev.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ProsesKurvaSKonsultan/:id',
    name: 'ProsesKurvaSKonsultan',
    component: () => import('../../components/views/Backoffice/Konsultan/ProsesKurvaS.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/KendalaTindakLanjutKonsultan/:id',
    name: 'KendalaTindakLanjutKonsultan',
    component: () => import('../../components/views/Backoffice/Konsultan/KendalaTindakLanjut.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/Finance/:id',
    name: 'Finance',
    component: () => import('../../components/views/Backoffice/Finance/Finance.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ProsesDIPA/:id',
    name: 'ProsesDIPA',
    component: () => import('../../components/views/Backoffice/Finance/ProsesDIPA.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ProsesSPM/:id',
    name: 'ProsesSPM',
    component: () => import('../../components/views/Backoffice/Finance/ProsesSPM.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/UserAbsensi',
    name: 'UserAbsensi',
    component: () => import('../../components/views/Backoffice/Absensi/UserAbsensi.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ProsesUserAbsensi/:id',
    name: 'ProsesUserAbsensi',
    component: () => import('../../components/views/Backoffice/Absensi/ProsesUserAbsensi.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ProsesDetailAbsensi/:id',
    name: 'ProsesDetailAbsensi',
    component: () => import('../../components/views/Backoffice/Absensi/ProsesDetailAbsensi.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/DataAbsensi',
    name: 'DataAbsensi',
    component: () => import('../../components/views/Backoffice/Absensi/DataAbsensi.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ProsesDataAbsensi/:id',
    name: 'ProsesDataAbsensi',
    component: () => import('../../components/views/Backoffice/Absensi/ProsesDataAbsensi.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/HariLibur',
    name: 'HariLibur',
    component: () => import('../../components/views/Backoffice/HariLibur/HariLibur.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ProsesHariLibur/:id',
    name: 'ProsesHariLibur',
    component: () => import('../../components/views/Backoffice/HariLibur/ProsesHariLibur.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/PengaturanIzin',
    name: 'PengaturanIzin',
    component: () => import('../../components/views/Backoffice/PengaturanIzin/PengaturanIzin.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ProsesPengaturanIzin/:id',
    name: 'ProsesPengaturanIzin',
    component: () => import('../../components/views/Backoffice/PengaturanIzin/ProsesPengaturanIzin.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/LokasiAbsensi',
    name: 'LokasiAbsensi',
    component: () => import('../../components/views/Backoffice/LokasiAbsensi/LokasiAbsensi.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/ProsesLokasiAbsensi/:id',
    name: 'ProsesLokasiAbsensi',
    component: () => import('../../components/views/Backoffice/LokasiAbsensi/ProsesLokasiAbsensi.vue'),
    meta: {
      transition: "zoom",
    },
  },
  {
    path: '/SettingMenu',
    name: 'SettingMenu',
    component: () => import('../../components/views/Backoffice/SettingMenu/SettingMenu.vue'),
    meta: {
      transition: "zoom",
    },
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  mode: 'history',
  routes: routes,
  linkActiveClass: 'active',
})

export default router;
